export default {
  common: {
    cancel: "Annuler",
    close: "Fermer",
    edit: "Modifier",
    archive: "Archiver",
    deactivate: "Désactiver",
    confirm: "Confirmer",
    none: "Aucun",
    unknown: "Inconnu",
    unavailable: "Indisponible",
    system: "Système",
    yes: "Oui",
    no: "Non",
    loading: "Chargement",
    notRecorded: "Non enregistré",
    notSelected: "Non sélectionné",
    noReason: "Aucune raison.",
    unassigned: "Non attribué",
    sensor: "Capteur",
    gateway: "Passerelle",
    device: "Dispositif d ' élément",
    elementSensor: "Capteur d ' élément",
    metric: "Métrique",
    email: "E-mail",
    messages: "Messages",
    needed: "Besoins",
    ready: "Prêt",
    noValue: "Aucune valeur",
    tracked: "Suivi",
    select: "Sélectionner",
    resolved: "résolus",
    channels: "canaux",
    staff: "du personnel",
    emails: "e-mails",
    until: "jusqu ' à",
    model: "Modèle",
    location: "Lieu",
    status: "Statut",
    notes: "Notes",
    name: "Nom",
    description: "Description",
    serialNumber: "Numéro de série",
    installLocation: "Installez l'emplacement",
    lastSeen: "Dernière vue",
    latestReading: "Dernière lecture",
    maintenance: "Maintenance",
    enabled: "Activé",
    disabled: "Désactivé",
    immediate: "Immédiat",
    minutes: "Minutes : {count}",
    minute: "Minutes : {count}",
    level: "Niveau {level}",
    and: "ET",
    countSensors: "Capteurs : {count}",
    countSensor: "Capteurs : {count}",
    countSelectedSensors: "Capteurs sélectionnés : {count}",
    countSelectedSensor: "Capteurs sélectionnés : {count}",
    breachPoint: "Points de dépassement dans la période sélectionnée : {count}.",
    breachPoints: "Points de dépassement dans la période sélectionnée : {count}.",
    resultReadings: "Relevés : {count}",
    resultReading: "Relevés : {count}",
    ending: "se terminant au {suffix}",
  },
  enum: {
    area: {
      multi_purpose: "Multi-usages",
      restroom: "Salle de repos",
      kitchen: "Cuisine",
      plant_room: "Chambre de la plante",
      accommodation: "Hébergement",
      outdoor: "Extérieur",
      wellness: "Bien-être",
      pool_spa: "Piscine / spa",
      gym: "Salle de sport",
      custom: "Personnalisé",
      general_building: "Bâtiment général",
      restrooms: "Salles de repos",
      kitchens: "Cuisines",
      boiler_plant_rooms: "Chaudière/chambres végétales",
      residence_hotel_rooms: "Résidence / chambres d'hôtel",
    },
    icon: {
      building: "Bâtiment",
      restroom: "Salle de repos",
      utensils: "Utensiles",
      settings: "Paramètres",
      bed: "Lit",
      tree: "Arbre",
      pool: "Piscine",
      dumbbell: "Clochette.",
      shield: "Bouclier",
      custom: "Personnalisé",
    },
    colour: {
      emerald: "Émeraude",
      blue: "Bleu",
      amber: "Ambre",
      purple: "Violet",
      gold: "Or",
      green: "Vert",
      slate: "Ardoise",
    },
    status: {
      active: "Actif",
      inactive: "Inactif",
      archived: "Archivé",
      online: "En ligne",
      offline: "Hors ligne",
      maintenance: "Maintenance",
      open: "Actif",
      acknowledged: "Remerciements",
      resolved: "Résolu",
      suppressed: "Supprimé",
      draft: "Brouillon",
      adopted: "Adoptée",
      provisioning: "Fournitures",
      pending_activation: "Activation en attente",
      failed: "Échec",
      normal: "Normale",
      warning: "Attention",
      critical: "Critique",
      info: "Information",
      unknown: "Inconnu",
      compliant: "Compliquant",
      attention: "Besoin d ' attention",
      not_started: "Pas commencé.",
      scheduled: "Planifié",
      retired: "Retraite",
      disabled: "Désactivé",
    },
    metric: {
      temperature: "Température",
      humidity: "Humidité",
      battery: "Batterie",
      signal: "Signal",
      gateway_online: "Gateway en ligne",
      sensor_online: "Senseur en ligne",
      co2: "CO2",
      pm2_5: "PM2,5",
      pm10: "PM10",
      fill_level: "Niveau de remplissage",
      rainfall: "Pluie",
      wind_speed: "Vitesse du vent",
      water_leak: "Fuite d ' eau",
      door_state: "État de la porte",
      vape_detected: "Vape détectée",
      fall_detected: "Automne détecté",
      presence: "Présence",
      odor_level: "Niveau Odeur",
      location: "Lieu",
      movement: "Mouvement",
      compound: "Conditions de production",
    },
    condition: {
      below: "ci-dessous",
      above: "ci-dessus",
      equals: "égales",
      not_reporting: "non not reporting",
    },
    severity: { info: "Information", warning: "Attention", critical: "Critique" },
    health: {
      normal: "Normale",
      warning: "Attention",
      critical: "Critique",
      offline: "Hors ligne",
    },
    action: {
      triggered: "Déclenchée",
      acknowledged: "Remerciements",
      assigned: "Affecté",
      resolved: "Résolu",
      auto_resolved: "Auto-résolue",
      suppressed: "Supprimé",
      maintenance_suppressed: "Supprimé pendant l'entretien",
      notification_sent: "Notification envoyée",
      notification_failed: "Notification échouée",
      escalation_sent: "Escalation sent",
    },
    reading: {
      leak: "Fuite",
      dry: "Séchage",
      open: "Ouvrir",
      closed: "Fermé",
      detected: "Détectée",
      clear: "Effacer",
      occupied: "occupés",
      vacant: "Vacants",
      elevated: "Élevée",
      normal: "Normale",
    },
    connection: {
      ethernet: "Éthernet",
      wifi: "Wi-Fi",
      cellular: "Cellulaire",
      lorawan: "LoRaWAN",
    },
    hardware: { gateway: "Passerelle", sensor: "Capteur" },
  },
  range: {
    last24Hours: "dernières 24 heures",
    last7Days: "7 derniers jours",
    lastMonth: "Le mois dernier",
    lastYear: "L'année dernière",
    short24h: "24h",
    short7d: "7d",
    short1m: "1m",
    short1y: "1y",
  },
  errors: {
    invalidGatewayEui: "Gateway EUI doit être 16 caractères hexadécimaux.",
    gatewayAlreadyAdopted: "Cette passerelle est déjà adoptée par ce club.",
    chirpstackGatewayExists:
      "Gateway existe déjà à ChirpStack; le reliant à ce club.",
    zoneKeyExists: "Une zone avec cette clé existe déjà.",
    deviceKeyExists: "Un dispositif avec cette clé existe déjà.",
    invalidDevEui: "DevEUI doit être 16 caractères hexadécimaux.",
    invalidJoinEui: "JoinEUI/AppEUI doit être de 16 caractères hexadécimaux.",
    invalidAppKey: "AppKey doit être 32 caractères hexadécimaux.",
    missingLorawanCredentials:
      "DevEUI, JoinEUI/AppEUI, et AppKey sont nécessaires.",
    thresholdRequired: "Entrez une valeur seuil.",
    notReportingRequired: "Entrez le nombre de minutes sans rapport.",
    ruleNameRequired: "Entrez un nom de règle.",
    scopeSensorRequired: "Sélectionnez un capteur.",
    scopeZoneRequired: "Sélectionnez une zone.",
    scopeGatewayRequired: "Sélectionnez une passerelle.",
    scopeGroupRequired: "Sélectionnez un groupe de capteurs.",
    recipientRequired:
      "Sélectionnez au moins un destinataire pour Privana Messages.",
    clubCodeMissing: "Le code du club n'a pas été trouvé sur la route actuelle.",
    overviewLoad: "Ne pouvait pas charger Privana Données de surveillance de l'élément.",
    zoneLoad: "Impossible de charger le détail de la zone.",
    graphLoad: "Impossible de charger la gamme de graphiques.",
    alertRulesLoad: "Impossible de charger les règles d'alerte.",
    alertCentreLoad: "Impossible de charger le centre d'alerte.",
    saveRule: "Incapable d'enregistrer une règle d'alerte.",
    deactivateRule: "Incapable de désactiver la règle.",
    saveZone: "Incapable de Enregistrer la zone Element.",
    saveDevice: "Incapable d'enregistrer l'appareil Element.",
    adoptHardware: "Incapable d'adopter du matériel.",
    updateHardware: "Impossible de mettre à jour le matériel.",
    assignSensor: "Impossible d'attribuer le capteur.",
    unassignSensor: "Incapable de désaffecter le capteur.",
    archiveZone: "Incapable à la zone d'archive.",
    deactivateDevice: "Incapable de désactiver le dispositif.",
    refreshGateway: "Impossible de rafraîchir le statut de passerelle en ce moment.",
    gatewaySyncFailed: "La synchronisation de Gateway a échoué",
    startMaintenance: "Impossible de commencer l'entretien.",
    endMaintenance: "Impossible de mettre fin à l'entretien.",
    actionAlert: "Impossible à {action} alerte.",
    cameraDenied:
      "La permission de la caméra a été refusée. Permettre l'accès à la caméra ou coller le texte QR à la place.",
    cameraMissing: "Aucun appareil photo n'a été trouvé sur cet appareil.",
    cameraStart:
      "Scanner n'a pas commencé. Permettre l'accès à la caméra, fermer d'autres applications de caméra, ou coller le texte QR à la place.",
    cameraUnavailable:
      "L'accès à la caméra n'est pas disponible dans ce contexte de navigateur. Utilisez la chute de pâte ou ouvrez Privana sur HTTPS.",
    scannerRegion: "Le conteneur de scanner n'a pas été rendu avant le démarrage de la caméra.",
    invalidPairing:
      "Ce lien de jumelage est invalide. Générer un nouveau lien à partir du modal de bureau.",
    pairingConnect: "Incapable de se connecter. Gardez cette page ouverte et essayez à nouveau.",
    photoDecode:
      "Ne peut pas décoder un code QR de cette photo. Remplissez le cadre avec le code QR et essayez à nouveau.",
    connecting: "Privana se connecte encore. Essayez de nouveau dans un instant.",
  },
  dashboard: {
    loadingLabel: "Chargement Privana Tableau de bord Element",
    filterZone: "Filtre par zone",
    filterZonePlaceholder: "Filtre par zone",
    allZones: "Toutes les zones",
    selectRange: "Sélectionnez la plage de temps",
    addZone: "Ajouter la zone",
    alertCentre: "Centre d’alertes",
    manageAlerts: "Gérer les alertes",
    refresh: "Actualiser",
    gatewayRefreshed: "Statut de la passerelle rafraîchie",
    gatewayRefreshedHelp: "Dernier statut de passerelle ChirpStack a été synchronisé.",
    lastRefreshed: "Dernière rafraichissement {date}",
    attention: "Privana L'élément a besoin d'attention",
    retry: "Réessayer",
    kpiLabel: "Privana Cartes KPI Element",
    systemHealth: "Santé du système",
    weightedEstate: "Score de la succession pondéré",
    activeAlerts: "Alertes actives",
    openAcknowledged: "Ouvert ou reconnu",
    sensorsOnline: "Senseurs en ligne",
    basedLastSeen: "Basée sur la dernière vue",
    zonesMonitored: "Zones surveillées",
    configuredZones: "Zones d ' éléments configurées",
    complianceStatus: "État de la conformité",
    fromCompliance: "Des registres de conformité",
    maintenanceDue: "Maintenance due",
    dueNext14: "Dû dans les 14 prochains jours",
    noZones: "Pas de zones Element configurées",
    noZonesHelp:
      "Créez des zones Element pour ce club afin de commencer à surveiller General Building, Restrooms, Kitchens, Plant Rooms, Residence & Hotel Rooms et Outdoor areas.",
    monitoredZones: "Zones surveillées",
    monitoredZonesHelp:
      "Sécurité de l'entreprise, environnement, hygiène, chaîne à froid et télémétrie extérieure.",
  },
  zone: {
    unnamed: "Zone dénommée",
    monitoredArea: "Zone surveillée",
    sensors: "Senseurs",
    online: "En ligne",
    alerts: "Alertes",
    assignedWaiting: "Les capteurs sont affectés; en attendant les premières lectures.",
    setupReady: "Configuration prête — assigner un capteur adopté à cette zone.",
    view: "Voir la zone",
    editLabel: "Modifier {name}",
    archiveLabel: "Archives {name}",
    detail: "Zone Détail",
    sensorDetail: "Détails du capteur",
    expandedGraph: "Graphique élargi",
    loading: "Zone de chargement...",
    back: "Retour",
    backToSensor: "Retour au capteur",
    assignedToZone: "Assignée à la zone",
    latestMetricPoints: "Derniers points de mesure",
    manage: "Gérer la zone",
    edit: "Modifier Zone",
    assignSensor: "Assigner un capteur",
    noCatalogue: "Aucun modèle de catalogue sélectionné",
    gatewayNetwork: "Passerelle / réseau",
    noSensors: "Pas de capteurs assignés",
    noSensorsHelp:
      "Assigner un capteur non affecté adopté pour commencer à collecter la télémétrie en direct Element pour cette zone.",
    latestReadings: "Dernières lectures",
    noReadings: "Pas de lectures pour cette zone",
    noReadingsHelp: "Les lectures apparaîtront une fois les appareils post-télémétrie.",
    create: "Créer une zone",
    formHelp:
      "Configurer comment cette zone Element apparaît dans le tableau de bord de surveillance actif.",
    name: "Nom de la zone",
    areaType: "Type de zone",
    iconKey: "Clé Icon",
    colourKey: "Touche couleur",
    descriptionPlaceholder: "Ce que cette zone couvre...",
    exampleName: "Bâtiment général",
    save: "Zone de sauvegarde",
    archive: "Zone d ' archives",
    archivePrompt:
      "Archiver cette zone? Les lectures et les alertes actuelles seront préservées.",
    archiveAction: "Zone d ' archives",
    archived: "Zone archivée",
    archivedHelp: "Des lectures et des alertes actuelles ont été conservées.",
    created: "Zone créée",
    updated: "Zone mise à jour",
    refreshed: "Privana Les zones d'éléments ont été rafraîchies.",
    saveFailed: "Zone sauvegardée",
    archiveFailed: "Archive échoué",
  },
  readings: {
    temperatureShort: "Tentation",
    humidity: "Humidité",
    battery: "Batterie",
    noNumericTitle: "Pas d'histoire numérique {metric}",
    noNumericHelp:
      "Une ligne de tendance apparaîtra une fois la télémétrie numérique reçue pour cette métrique.",
    chartLabel: "{metric} diagramme de tendance",
    expandLabel: "Agrandir le graphique {metric}",
    lastUpdated: "Dernière mise à jour {date}",
    safeRange: "Gamme de sécurité {min} – {max}",
    noSafeRange: "Aucun seuil configuré pour une bande de sécurité.",
    latestValue: "Dernière valeur",
    selectedRange: "Gamme choisie",
    loadingRange: "Chargement de la gamme sélectionnée...",
    loading: "Chargement",
    sensorGraphs: "Graphiques de capteurs",
    liveTelemetry: "Télémétrie Live Element",
    defaultRange: "Plage par défaut: {range}",
    noHistory: "Pas encore de lectures historiques",
    noHistoryHelp:
      "Les cartes graphiques apparaîtront alors que ce capteur affiche la température, l'humidité, la batterie ou d'autres paramètres élémentaires.",
    noThreshold: "Aucun seuil configuré",
    breach: "Violation: {reason}",
    thresholdLimit: "Limite de seuil: {limit}",
    severity: "Gravité : {severity}",
    threshold: "Seuil : {name}",
  },
  panels: {
    activeAlerts: "Alertes actives",
    noActiveAlerts: "Aucune alerte active",
    noActiveAlertsHelp:
      "Les alertes Open Element apparaîtront ici avec des actions de reconnaissance et de résolution.",
    acknowledge: "Remerciements",
    resolve: "Résoudre le problème",
    reviewTelemetry: "Examen de la télémétrie de l'appareil.",
    unassignedZone: "Zone non affectée",
    quickInsights: "Aperçus rapides",
    complianceSummary: "Résumé du respect des dispositions",
    currentStatus: "État actuel",
    latest: "Dernières: {title} · {date}",
    complianceReport: "Rapport d ' examen",
    noCompliance: "Aucun rapport de conformité n ' a encore été produit",
    noComplianceHelp:
      "Les registres de conformité d'éléments résumeront les données de sécurité, d'hygiène et de surveillance générées une fois que la déclaration sera activée.",
    recentActivity: "Activité récente",
    telemetry: "Télémétrie d ' élément",
    noActivity: "Aucune activité récente",
    noActivityHelp:
      "Les alertes, les lectures et les actions d'alerte spécifieront ce flux comme les appareils envoient la télémétrie.",
    trend: "24h Aperçu général de la tendance",
    readingCounts: "La lecture compte à l'heure",
    noTrend: "Aucun relevé sur 24 h pour le moment",
    noTrendHelp:
      "Les barres de tendance apparaîtront après la télémétrie en direct est ingérée des appareils Milesight.",
  },
  insight: {
    hardwareReadyTitle: "L ' adoption du matériel",
    hardwareReadyDetail: "Adopter du matériel une fois, puis attribuer des capteurs aux zones.",
    offlineOne: "Appareils hors ligne : {count}",
    offlineMany: "Appareils hors ligne : {count}",
    offlineDetail: "Examen des derniers timestamps vus et de la connectivité LoRaWAN.",
    alertsOne: "Alertes actives : {count}",
    alertsMany: "Alertes actives : {count}",
    alertsDetail: "Remerciements ou résolution des alertes du panneau Alertes actives.",
    zonesOne: "Zones en attente de capteurs : {count}",
    zonesMany: "Zones en attente de capteurs : {count}",
    zonesDetail: "Assigner des capteurs non affectés aux zones surveillées.",
    awaitingTitle: "Attendant les premières lectures",
    awaitingDetail:
      "Le point d'extrémité d'ingestion est prêt pour le décollage Milesight API /MQTT.",
    sustainabilityTitle: "Note de durabilité {score}",
    sustainabilityDetail: "Dernier calcul de durabilité de l'élément.",
    stableTitle: "Élément domaine stable",
    stableDetail: "Aucune exception active détectée dans les zones surveillées.",
  },
  activity: {
    readingTitle: "{metric} lecture reçue",
    actionTitle: "Enregistrés : {action}",
  },
  alert: {
    fallbackTitle: "Alerte à l ' élément",
    unknownDevice: "Dispositif inconnu",
    assignedTo: "Assigné à {name}",
    acknowledgedBy: "Reconnu par {name}",
    notAcknowledged: "Non reconnu",
    takeOwnership: "Propriétaires",
    auditTrail: "Journal d’audit",
    auditDescription: "{title} événements de cycle de vie.",
    search: "Alertes de recherche",
    exportSoon: "Export CSV (à venir)",
    exportSoonTitle: "CSV exportation à venir bientôt",
    exportSoonHelp:
      "L'exportation est bientôt à venir — todo: centre d'alerte filaire CSV exportation.",
    loading: "Chargement des alertes...",
    centreHelp:
      "Actif, reconnu, résolu, supprimé et augmenté Privana Alertes Element avec le contexte de propriété opérationnelle.",
    historyLoadFailed: "L ' histoire de l ' alerte n ' a pas été chargée",
    actionComplete: "Alerte {action} complète",
    ownershipComment: "Tiré du Centre d ' alerte",
    manageTitle: "Gérer les alertes",
    manageHelp:
      "Créez, modifiez, désactivez et révisez les règles de seuil d'alerte Privana.",
    manageGroups: "Gérer les groupes de capteurs",
    createRule: "Créer une règle d'alerte",
    existingRules: "Règles d ' alerte existantes",
    loadingRules: "Chargement des règles...",
    noRules: "Aucune règle d'alerte configurée",
    noRulesHelp:
      "Créer une batterie, l'humidité, la température, le signal, l'état en ligne ou une règle de non-signalage pour commencer la surveillance des seuils.",
    recipients: "Bénéficiaires : {recipients}",
    duration: "Durée: {duration}",
    cooldown: "Refroidissement : {duration}",
    channels: "Canaux: {channels}",
    autoResolve: "Auto-résolve: {value}",
    notifyResolve: "Avertissement à la résolution: {value}",
    escalations: "Escalades : {value}",
    noStaff: "Pas de personnel sélectionné",
    recentHistory: "Histoire récente déclenchée ou résolue",
    sendTest: "Alerte aux essais",
    testSent: "Alerte TEST envoyée",
    testSentHelp: "La notification d'essai a été enregistrée et étiquetée comme ESSAI.",
    deactivated: "Règle d ' alerte désactivée",
    deactivateFailed: "Désactivation échouée",
    saved: "Règle d ' alerte sauvegardée",
    savedHelp: "Privana Les seuils d'alerte de l'élément ont été mis à jour.",
    saveFailed: "Règle d ' alerte sans échec",
    rulesLoadFailed: "Les règles d ' alerte n ' ont pas été chargées",
    status: {
      active: "Actif",
      acknowledged: "Remerciements",
      resolved: "Résolu",
      suppressed: "Supprimé",
    },
    rule: {
      edit: "Modifier la règle d ' alerte",
      create: "Créer une règle d'alerte",
      help: "Configurer une condition ou exiger plusieurs conditions pour tous rester vrai pendant la durée.",
      save: "Enregistrer des règles.",
      name: "Nom de la règle",
      namePlaceholder: "Batterie inférieure à 10%",
      severity: "Gravité",
      scope: "Champ d ' application",
      allSensors: "Tous les capteurs",
      specificSensor: "Capteur spécifique",
      specificZone: "Zone spécifique",
      specificGateway: "Portes spécifiques",
      sensorGroupScope: "Groupe capteur / capteurs multiples",
      sensorGroup: "Groupe capteur",
      selectGroup: "Sélectionnez le groupe de capteur",
      noGroups:
        "Pas de groupes de capteurs configurés. Créez-en un auprès de Groupes de capteurs.",
      durationBefore: "Durée avant le déclenchement",
      customMinutes: "Minutes personnalisées",
      repeatInterval: "Intervalle de refroidissement/répétition",
      ruleCap: "Règle du plafond de notification quotidienne",
      deviceCap: "Cap de notification quotidienne de l'appareil",
      cycleCap: "Capuchon de notification du cycle de travail",
      conditions: "Conditions",
      conditionsHelp:
        "Toutes les conditions doivent être vraies. Ajouter des rangées d'humidité + de température pour les règles des composés.",
      addCondition: "Ajouter la condition",
      remove: "Retirer",
      minutesNotReporting: "Procès-verbal sans rapport",
      threshold: "Seuil",
      escalationPath: "Chemin d ' escalade",
      escalationHelp:
        "Le niveau 1 utilise les premiers destinataires. Les niveaux 2 et 3 envoient une fois sans résolution après les minutes configurées.",
      escalateAfter: "Escalat après quelques minutes",
      fallbackEmails: "courriels Fallback",
      staffRecipients: "Récipiendaires du personnel",
      staffRecipientsHelp:
        "Privana Les notifications de messages exigent des utilisateurs du personnel sélectionnés. Email utilise également leurs adresses email du personnel.",
      messagesNotification: "Privana Notification des messages",
      autoResolveNormal: "Auto-resolve quand normal",
      notifyOnResolve: "Avertissement à la résolution",
      manualEmails: "Courriels de destinataires manuels (advanced/fallback)",
      selectedRequired:
        "Sélectionnez au moins un destinataire pour Privana Messages.",
      scopeSensor: "Senseur: {name}",
      scopeZone: "Zone : {name}",
      scopeGateway: "Passerelle: {name}",
      scopeGroup: "Groupe de capteur: {name}",
      notReporting: "{metric} sans rapport pour {minutes} minutes",
      comparison: "{metric} {condition} {value}",
      escalationSummary:
        "L {level} après {minutes} m ( {staff} employés, {emails} e-mails, {channels} )",
    },
    groups: {
      title: "Gérer les groupes de capteurs",
      help: "Créer des groupes de capteurs Element séparés des zones pour le ciblage d'alerte.",
      name: "Nom du groupe",
      namePlaceholder: "Tous les congélateurs",
      saved: "Groupe capteurs enregistrés",
      archived: "Groupe de capteur archivé",
      save: "Enregistrer le groupe",
      create: "Créer un groupe",
    },
  },
  hardware: {
    adoptedTitle: "Adopté du matériel",
    adoptedHelp: "Gateways et capteurs enregistrés dans ce club.",
    manage: "Gérer le matériel",
    adopting: "Adopter...",
    adopt: "Adopter le matériel",
    totalSensors: "Total des capteurs adoptés",
    totalGateways: "Total des passerelles",
    unassignedSensors: "Capteurs non affectés",
    offlinePending: "Dispositifs hors ligne/dépendance",
    overview: "Vue d’ensemble",
    gateways: "Passerelles",
    sensors: "Senseurs",
    adoptTab: "Adopter du matériel",
    gatewaysAdopted: "Passerelles adoptées",
    sensorsAdopted: "Senseurs adoptés",
    pendingActivation: "Activation en attente",
    onlineDevices: "Dispositifs en ligne",
    overviewTitle: "Adopter du matériel une fois, puis attribuer des capteurs aux zones.",
    overviewHelp:
      "Gateways reste comme une infrastructure de niveau club. Les capteurs restent en inventaire jusqu'à ce qu'ils soient affectés à une zone surveillée.",
    overviewAssignHelp:
      "Les capteurs sont affectés à des zones situées à l’intérieur de chaque zone. Utilisez le capteur d’affectation à l’intérieur d’une zone pour déployer du matériel.",
    noGateways: "Pas de passerelles adoptées",
    noGatewaysHelp:
      "Adopter une passerelle pour enregistrer l'infrastructure réseau au niveau des clubs.",
    noSensors: "Aucun capteur n ' est adopté",
    noSensorsHelp: "Adoptez des capteurs, puis assignez des capteurs disponibles aux zones.",
    gatewayModelMissing: "Modèle Gateway non sélectionné",
    sensorModelMissing: "Modèle de capteur non sélectionné",
    gatewayEui: "Passerelle eui",
    sensorsUsingGateway: "Senseurs utilisant la passerelle",
    connectionType: "Type de connexion",
    edit: "Modifier",
    endMaintenance: "Fin de la maintenance",
    startMaintenance: "Incorporer la maintenance",
    editHardware: "Modifier {kind}",
    editHelp: "Mettre à jour les détails du matériel adopté.",
    provisioningStatus: "État de destination",
    protectedIdentity: "Identité protégée ChirpStack.",
    save: "Enregistrer du matériel",
    updated: "Matériel mis à jour",
    updatedHelp: "Les détails matériels adoptés ont été sauvegardés.",
    updateFailed: "Mise à jour du matériel échoué",
    adopted: "Matériel adopté",
    adoptedSuccess: "L'appareil est maintenant enregistré dans ce club.",
    adoptionFailed: "Adoption échouée",
    deactivated: "Dispositif désactivé",
    deactivatedHelp: "Des lectures et des alertes historiques ont été conservées.",
    deactivateFailed: "Désactivation échouée",
    deactivateTitle: "Désactiver le dispositif",
    deactivatePrompt:
      "Désactiver cet appareil? Les lectures et les alertes historiques seront conservées.",
    deactivateAction: "Désactiver le dispositif",
    assignTitle: "Assigner un capteur",
    assignHelp: "Sélectionnez un capteur non assigné adopté pour {zone} .",
    thisZone: "cette zone",
    unassignedSensor: "Senseur non affecté",
    noModel: "Pas de modèle",
    noAssignable: "Pas de capteurs assignables",
    noAssignableHelp: "Adopter un nouveau capteur d'abord, puis l'affecter à cette zone.",
    adoptInstead: "Adopter un nouveau capteur à la place",
    assign: "Assigner un capteur",
    assigned: "Senseur assigné",
    assignedHelp: "{zone} liste de périphériques a été rafraîchie.",
    assignFailed: "Assignation échouée",
    unassignedToast: "Senseur non affecté",
    unassignedHelp: "Le capteur est retourné à l'inventaire non affecté.",
    unassignFailed: "Insigne a échoué",
    editAssignment: "Modifier l ' affectation",
    unassignFromZone: "Désaffectation de la zone",
    actionsLabel: "Actions ouvertes pour {name}",
    maintenanceTitle: "Incorporer la maintenance",
    maintenanceHelp:
      "Suppresser les notifications d'alerte pour ce dispositif ou passerelle pendant que les lectures continuent d'être enregistrées.",
    maintenanceReason: "Raison d ' entretien",
    maintenancePlaceholder:
      "Remplacement des piles, relocalisation des passerelles, étalonnage...",
    optionalEnd: "Date de fin facultative/heure",
    startMaintenanceAction: "Démarrage de la maintenance",
    maintenanceEnabled: "Mode de maintenance activé",
    maintenanceEnabledHelp: "{device} notifications seront supprimées.",
    maintenanceEnded: "Fin de la maintenance",
    maintenanceEndedHelp: "{device} notifications d'alerte ont repris.",
    maintenanceFailed: "Maintenance échouée",
    adoption: {
      step: "Étape 1: Choisissez le type de matériel",
      regionResolved: "LoRaWAN région: {region} , résolu à partir de {source} .",
      regionClubCountry: "pays du club {country}",
      regionMissing:
        "La région de LoRaWAN n’a pas pu être résolue à partir de l’adresse de ce club. Veuillez remplir l’adresse du club avant d’adopter le matériel LoRaWAN.",
      gatewayName: "Nom de la passerelle",
      gatewayNamePlaceholder: "Main clubhouse passerelle",
      gatewayModel: "Modèle de passerelle/catalogue",
      serialOptional: "Numéro de série (facultatif)",
      serialPlaceholder: "Numéro de série Milesight",
      locationPlaceholder: "Porte-chambre IT",
      sensorName: "Nom du capteur",
      sensorNamePlaceholder: "Capteur de fuite des salles de repos",
      sensorModel: "Modèle de capteur/catalogue",
      preferredGateway: "Passerelle/réseau privilégié",
      pairingCode: "Code de paire / code QR / numéro de série",
      pairingPlaceholder: "Référence en série ou QR facultative",
      sensorLocationPlaceholder: "Sous lavabo 2",
      notesPlaceholder: "Notes d ' installation facultative",
      gatewayHelp:
        "Gateways nécessite une passerelle EUI pour ChirpStack. Numéro de série est optionnel et maintenu séparé de Gateway EUI.",
      scanQr: "Code QR de Scan",
      scanQrHelp:
        "Scannez le code QR de l'étiquette ou de l'emballage du capteur. Privana extraira automatiquement les détails de LoRaWAN.",
      scanCamera: "Scan avec caméra",
      scanPhone: "Scan avec votre téléphone",
      scanPhoneHelp:
        "Ouvrez cette paire QR sur un téléphone à côté du capteur. Le scanner mobile enverra DevEUI, JoinEUI/AppEUI, AppKey et le modèle détecté à cette session de bureau.",
      waitingPhone: "En attendant l'analyse de téléphone...",
      newQr: "Nouvelle paire QR",
      pasteQr: "Paste QR text here if camera numérisation is unavailable",
      pasteQrLabel: "Texte QR passé",
      parseQr: "Code QR de Parse",
      stopCamera: "Arrêtez la caméra.",
      credentials: "Pouvoirs de LoRaWAN",
      appKeyCaptured: "AppKey capturé {ending} .",
      appKeyMissing: "AppKey n'a pas encore été capturé.",
      devEui: "DevEUI",
      joinEui: "JoinEUI/AppEUI",
      serialNotFound: "Pas encore trouvé",
      nextStep:
        "Prochaine étape: Trouver JoinEUI/AppEUI et AppKey dans Milesight ToolBox ou la fiche de disposition de l'appareil.",
      manualTitle: "Détails du LoRaWAN manuel — Advanced",
      manualHelp: "L'entrée manuelle est réservée aux installateurs techniques.",
      appKeyEncrypted: "Stocké crypté après adoption",
      milesightHelp:
        "Milesight par défaut AppKey est communément le DevEUI répété deux fois. Surcharger si votre feuille de provisionnement dit autrement.",
      qrReady: "{source} parsed. Les détails de LoRaWAN sont prêts pour l'adoption.",
      qrSerialOnly:
        "QR trouvé, mais il ne contient que le numéro de série. Les clés LoRaWAN sont toujours nécessaires.",
      qrMissingKeys: "QR trouvés, mais JoinEUI/AppKey sont toujours nécessaires.",
      qrNoCredentials: "{source} trouvé, mais aucun identifiant LoRaWAN n'a été trouvé.",
      phoneSource: "Scan de téléphone",
      phoneModel: "Scan de téléphone reçu. Modèle de capteur détecté: {model}",
      phoneUpdated: "Les champs de bureau ont été mis à jour.",
      phoneUnavailable:
        "Impossible de connecter le couplage de téléphone. Collez le texte QR à la place.",
      requestingCamera: "Demande d'autorisation de caméra...",
      cameraActive:
        "Caméra active — remplir la case avec le code QR. Appuyez sur l'aperçu pour se concentrer.",
      scanNoCredentials:
        "QR a trouvé mais aucun identifiant LoRaWAN n'a trouvé. Essayez de nouveau de balayer ou de coller le texte QR à la place.",
    },
  },
  device: {
    edit: "Modifier le périphérique",
    add: "Ajouter le dispositif",
    formHelp:
      "Sélectionnez le modèle de catalogue et ne gérez que les détails opérationnels indiqués au personnel.",
    zone: "Zone",
    typeModel: "Type d'appareil / modèle de catalogue",
    name: "Nom du dispositif",
    namePlaceholder: "Réfrigérateur de cuisine",
    locationPlaceholder: "Paroi nord",
    maintenanceDue: "Date d ' expiration de l ' entretien",
    save: "Sauvegarder un périphérique",
    added: "Appareil ajouté",
    updated: "Appareil mis à jour",
    refreshed: "Les affectations d'appareils de zone ont été rafraîchies.",
    saveFailed: "Enregistrement de périphérique échoué",
  },
  pairing: {
    connecting: "Connexion à Privana ...",
    title: "Code QR du capteur de détection",
    subtitle:
      "Privana enverra les détails de LoRaWAN à l'adoption de bureau modal.",
    boxHelp: "Remplissez la boîte avec le code QR. Appuyez sur pour vous concentrer.",
    standby: "Caméra scanner standby",
    uploadFallback: "Chargement/retour de la photo",
    upload: "Chargement/Première photo",
    toolboxHelp:
      "Trouvez JoinEUI/AppEUI et AppKey dans Milesight ToolBox ou la feuille de fourniture de l'appareil.",
    pasteFallback: "Pénétré du texte QR passé",
    pastePlaceholder: "Coller le texte QR si la numérisation de la caméra est indisponible",
    stopCamera: "Arrêtez la caméra.",
    startCamera: "Démarrer le scanner de caméra",
    send: "Envoyer",
    qrSource: "Code QR",
    qrReady: "{source} parsed. Les détails de LoRaWAN sont prêts.",
    qrSerialOnly:
      "QR trouvé, mais il ne contient que le numéro de série. Les clés LoRaWAN sont toujours nécessaires.",
    qrMissingKeys: "QR trouvés, mais JoinEUI/AppKey sont toujours nécessaires.",
    qrNoCredentials:
      "{source} trouvé mais aucun identifiant LoRaWAN n'a trouvé. Essayez de nouveau de rechercher, en prenant une photo ou en collant un texte QR.",
    sentReady: "Détails loRaWAN envoyés à l'adoption de bureau modal.",
    sentPartial: "{status} Détails envoyés au bureau modal.",
    requestingCamera: "Demande d'autorisation de caméra...",
    cameraActive:
      "Caméra active — remplir la case avec le code QR. Appuyez sur l'aperçu pour se concentrer.",
    connectedReopen: "Rouvrir le dernier scanner de caméras...",
    connectedReady: "Connecté. Appuyez sur Démarrer le scanner de caméra ou Décharger/Prendre photo.",
    decoding: "Décoder QR de la photo...",
    diagnostics: "Diagnostics qR",
    diagnosticsMediaDevices: "navigateur.mediaDevices disponibles?",
    diagnosticsGetUserMedia: "Accès aux médias de la caméra disponible?",
    diagnosticsSecureContext: "Contexte sécurisé du navigateur?",
    diagnosticsLocation: "Page",
    diagnosticsLoaded: "L'analyseur QR est chargé avec succès ?",
    diagnosticsStartError: "Erreur de démarrage du scanner QR",
    warnings: {
      empty: "Collez ou numérisez un code QR d'abord.",
      serialOnly:
        "QR trouvé, mais il ne contient que le numéro de série. Les clés LoRaWAN sont toujours nécessaires.",
      missingKeys: "QR trouvés, mais JoinEUI/AppKey sont toujours nécessaires.",
      partial:
        "Certains détails de LoRaWAN ont été trouvés, mais JoinEUI/AppEUI et AppKey sont tous les deux nécessaires.",
      none: "Aucun identifiant LoRaWAN n'a été trouvé. Essayez de coller le texte complet du QR ou d'utiliser les détails du manuel LoRaWAN.",
      toolbox:
        "Trouvez JoinEUI/AppEUI et AppKey dans Milesight ToolBox ou la feuille de fourniture de l'appareil.",
      invalidHex: "{field} doit être {count} caractères hexagonaux.",
    },
  },
};
